"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { RiDownloadLine, RiFileLine } from "react-icons/ri";
import { MessageImages } from "@/app/[tenant]/(console)/comms/chat/window/message/message-images";
import { isImageFile } from "@/components/chat/attachments";
import { cx } from "@/lib/tailwind-utils";
import type { TeamFileInfo } from "@/types/team-chat";
interface MessageAttachmentsProps {
  files: TeamFileInfo[];
  /** Styles the file tiles for the sender's primary-colored bubble. */
  isOwn?: boolean;
  className?: string;
}

/** Image gallery plus downloadable file tiles, shared by Whisper and task comments. */
export function MessageAttachments(t0) {
  const $ = _c(13);
  const {
    files,
    isOwn: t1,
    className
  } = t0;
  const isOwn = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== files) {
    const imgs = [];
    const others = [];
    for (const f of files) {
      if (isImageFile(f.url)) {
        imgs.push(f.url);
      } else {
        others.push(f);
      }
    }
    t2 = {
      images: imgs,
      nonImageFiles: others
    };
    $[0] = files;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    images,
    nonImageFiles
  } = t2;
  if (files.length === 0) {
    return null;
  }
  let t3;
  if ($[2] !== className) {
    t3 = cx("flex flex-col gap-1.5", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== images) {
    t4 = images.length > 0 && <MessageImages images={images} />;
    $[4] = images;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isOwn || $[7] !== nonImageFiles) {
    t5 = nonImageFiles.length > 0 && <div className="flex flex-col gap-1">{nonImageFiles.map((file, i) => file.url && file.url !== "#" ? <a key={i} href={file.url} target="_blank" rel="noopener noreferrer" download={file.name} className={cx("flex items-center gap-2 rounded-lg border px-2.5 py-1.5 transition-colors", isOwn ? "border-primary-foreground/20 bg-primary-foreground/10 hover:bg-primary-foreground/20" : "border-border bg-background hover:bg-hover")}><RiFileLine className={cx("h-4 w-4 shrink-0", isOwn ? "text-primary-foreground/70" : "text-foreground-secondary")} /><span className={cx("min-w-0 flex-1 truncate text-caption", isOwn ? "text-primary-foreground" : "text-foreground")}>{file.name}</span><RiDownloadLine className={cx("h-3.5 w-3.5 shrink-0", isOwn ? "text-primary-foreground/70" : "text-foreground-secondary")} /></a> : <div key={i} className={cx("flex items-center gap-2 rounded-lg border px-2.5 py-1.5", isOwn ? "border-primary-foreground/20 bg-primary-foreground/10" : "border-border bg-background")}><RiFileLine className={cx("h-4 w-4 shrink-0", isOwn ? "text-primary-foreground/70" : "text-foreground-secondary")} /><span className={cx("min-w-0 flex-1 truncate text-caption", isOwn ? "text-primary-foreground" : "text-foreground")}>{file.name}</span></div>)}</div>;
    $[6] = isOwn;
    $[7] = nonImageFiles;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}